export const APP_PLATFORM = process.env.REACT_APP_PLATFORM || "web";
export const isWindowsApp = APP_PLATFORM === "windows";
export const isAndroidApp = APP_PLATFORM === "android";
export const ANDROID_DISTRIBUTION = isAndroidApp
  ? (process.env.REACT_APP_ANDROID_DISTRIBUTION || "play").toLowerCase()
  : null;
export const isAndroidDirect = isAndroidApp && ANDROID_DISTRIBUTION === "direct";
export const isAndroidPlayConsumptionOnly = isAndroidApp && ANDROID_DISTRIBUTION === "play";
export const androidCapabilities = Object.freeze({
  payments: isAndroidDirect,
  studentRenewal: isAndroidDirect,
  teacherWalletRecharge: isAndroidDirect,
  teacherWorkspace: isAndroidDirect,
});

const PUBLIC_WEB_ORIGIN = (process.env.REACT_APP_WEB_BASE_URL || "https://www.quicklearning-cmr.com").replace(/\/$/, "");

export const openPublicLegalPage = async (path) => {
  const url = new URL(path, `${PUBLIC_WEB_ORIGIN}/`);
  if (url.origin !== new URL(PUBLIC_WEB_ORIGIN).origin) throw new Error("URL_PUBLIQUE_REFUSEE");
  if (isAndroidApp) {
    const browser = window.Capacitor?.Plugins?.Browser;
    if (typeof browser?.open !== "function") throw new Error("OUVERTURE_EXTERNE_INDISPONIBLE");
    await browser.open({ url: url.toString() });
    return;
  }
  window.open(url.toString(), "_blank", "noopener,noreferrer");
};
